export const LOT_PAIEMENT_FACTURES_ACHAT_STORE = 'lotPaiementFacturesAchat';
export const JOURNAL_PAIEMENT_FACTURES_ACHAT_STORE = 'journalPaiementFacturesAchat';
